<template>
    <div class="card">

        <div class="card-header">
            <div class="col-md-12">
                <h4>
                    <i class="fa fa-edit"></i>
                    {{'New job'|trans}}
                </h4>
            </div>
        </div>

        <div class="row card-body " id="new-job-form" v-if="isAddingNewJob">
            <div class="alert alert-success text-center" >
                <strong>{{'Your new job has been added'|trans}}</strong>
            </div>
        </div>

        <div class="row card-body " id="new-job-form" v-if="isAddingNewJob !== true">
            <JobForm :job="job" :user="user" v-on:submit="submitNewJob"></JobForm>
        </div>

    </div>
</template>

<script>


	import JobForm from "./JobForm";
	export default {
		components: {JobForm},
		props: {
			user: Object
		},
		data: function () {
			return {
				isAddingNewJob : false,
				timeRequiredForJob: [
					{'label': '40min', 'value': 40},
					{'label': '1h00', 'value': 60},
					{'label': '1h20', 'value': 80},
					{'label': '2h00', 'value': 120},
					{'label': '3h00', 'value': 180},
					{'label': '6h00', 'value': 360},
					{'label': '9h00', 'value': 540},
					{'label': '+', 'value': 0},
				],
				job: {
					interventionType:'new',
			    	dateJobStart:null,
					description: null,
					timeRequired: null,
					jobTypeId: null,
					customer: {
						lastName: null,
						language: null,
						email: null,
						phone : null
					},
					address: {
						zoneId: null,
						street: null,
						number: null,
					},
				},
			};
		},
		methods: {
			async submitNewJob() {
				this.isAddingNewJob = true;
                try {
                    let responseJobAdded = await this.$api.job.addJobAsWorkerOwner(this.job);
                }
                catch (error) {
                    if (this.$api.is401(error)) {
                        // in case of 401, just abort javascript execution
                        return;
                    }
                    if (this.$api.isCancel(error)) {
                        // request canceled programmatically, let the new request do the job
                        return;
                    }
                    if (this.$api.isNoConnectivity(error)) {
                        this.errorMessage = this.$options.filters.trans('No connection ?');
                    } else {
                        this.$bugsnagClient.notify(error);
                        this.errorMessage = this.$options.filters.trans('Unknown error');
                    }
                }
			},
		},
        filters:{

        }
	}
</script>

<style scoped>
    .row > [class*="col-"] {
        margin-bottom: 10px !important;
    }
    .card .card-body{
        padding:10px;
    }
</style>

<style>
    #new-job-form .full-width {
        width: 100%;
    }

    #new-job-form .error-validation label {
        color: red !important;
    }


</style>
